import React from "react";
import Mydata from "@/app/data/blog/chicago-Ohare.json";
function hero() {
  const Data = Mydata[1];
  return (
    <div className="mx-auto max-w-5xl px-4 text-[#2B3252] text-lg">
      {Data.Mainheading.map((section, index) => (
        <div key={index} className="mb-8">
          {/* Main Title */}
          {section && <h2 id={section.id} className="blogtitle">{section.title}</h2>}
          {/* Content Sections */}
          {section && <p className="blogcontent">{section.content}</p>}
          {section && <p className="blogcontent">{section.content1}</p>}

          {/* Terminal and Image (if available) */}
          {section.terminal && (
            <h3 id={section.id} className="blogSubtitle">{section.terminal}</h3>
          )}
          {section.image && (
            <img
              src={section.image}
              alt={section.title}
              className="blogcontent rounded-[20px]"
            />
          )}

          {/* Additional Content Sections */}
          {section && (
            <p
              className="blogcontent"
              dangerouslySetInnerHTML={{ __html: section.content2 }}
            ></p>
          )}
          {section && (
            <p
              className="blogcontent"
              dangerouslySetInnerHTML={{ __html: section.content3 }}
            ></p>
          )}

          {/* Bulletpoints List */}
          {section.bulletpoints && (
            <ul className="mt-2 pl-4">
              {section.bulletpoints.map((bullet, bulletIndex) => (
                <li
                  key={bulletIndex}
                  className="list-disc  blogcontent"
                  dangerouslySetInnerHTML={{ __html: bullet }}
                />
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
}

export default hero;
